// angular
// 	.module("HeroPRO")
// 	.factory("actionItemFiltersFactory", actionItemFiltersFactory);

import _ from 'lodash';

/* @ngInject */
export default function actionItemFiltersFactory(HPConfig, $http) {
    const filterOptions = {};
    // Default Filters
    let selectedFilters = {
        ActionItemStatuses: [1, 4],
    };

    return {
        getActionItemFilterOptions,
        getSelectedActionItemFilters,
        setActionItemFilter,
        resetFilters,
    };

    /*= ========================================
	=            Public Functions            =
	========================================= */
    function getActionItemFilterOptions() {
        const request = $http({
            url: `${HPConfig.heroProApi}ActionItem/getFilters`,
            method: 'GET',
            params: {},
        });

        return request.then(handleSuccess, handleError);
    }

    function getSelectedActionItemFilters() {
        return selectedFilters;
    }

    function setActionItemFilter(filterName, value) {
        switch (filterName) {
        case 'ActionItemStatuses':
            selectedFilters.ActionItemStatuses = setActionItemStatusId(value);
            break;
        case 'ActionItemLabels':
            if (value === 0) {
                delete selectedFilters.ActionItemLabels;
            } else {
                selectedFilters.ActionItemLabels = [value];
            }
            break;
        default:
            selectedFilters[filterName] = value;
        }
    }

    function resetFilters() {
        selectedFilters = {
            ActionItemStatuses: [1, 4],
        };
    }
    /* -----  End of Public Functions  ------*/


    /*= ========================================
	=            Private Functions            =
	========================================= */
    function setActionItemStatusId(status) {
    	const actionItemStatuses = [];

    	switch (status) {
    		case 0:
    			actionItemStatuses.push(1);
    			actionItemStatuses.push(3);
    			actionItemStatuses.push(4);
    			actionItemStatuses.push(5);
    			break;
        case 1:
            actionItemStatuses.push(1);
            actionItemStatuses.push(4);
    			break;
        case 3:
            actionItemStatuses.push(3);
    			break;
        case 5:
            actionItemStatuses.push(5);
    			break;
    	}

    	return actionItemStatuses;
    }

 	function modifyLabelOptions(data) {
        filterOptions.ActionItemLabels = data;
 		// Add an All option
        filterOptions.ActionItemLabels.unshift({ ActionItemLabelId: 0, ActionItemLabelDescription: 'All' });
 	}

 	function modifyStatusOptions(data) {
 		filterOptions.ActionItemStatuses = data;
        // Remove the Dismissed and Invalidated options
        filterOptions.ActionItemStatuses = _.filter(filterOptions.ActionItemStatuses, status => status.ActionItemStatusName !== 'Invalidated' && status.ActionItemStatusName !== 'Initiated');
 		// Add an All option
        filterOptions.ActionItemStatuses.unshift({ ActionItemStatusId: 0, ActionItemStatusName: 'All' });
 	}

    function handleSuccess(response) {
        modifyLabelOptions(response.data.ActionItemLabels);
        modifyStatusOptions(response.data.ActionItemStatuses);

        return filterOptions;
    }

    function handleError(response) {
        return response.data;
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/actionItems/actionItemFiltersFactory.js